<template>
  <div class="dg-title" :class="{ 'line': line }">
    <span class="t-[16] font-600  t-[#303133] txt">
      <slot></slot>
    </span>
    <slot name="tip"></slot>
  </div>
</template>
<script>
export default {
  name: 'dg-title',
  data() {
    return {}
  },
  props: {
    line: Boolean
  },
  methods: {},
  mounted() { },
  created() { },
}
</script>
<style lang="less" scoped>
@import '~@/assets/css/var.less';

.dg-title {
  position: relative;

  // padding: 16px 0;
  &.line::before {
    content: '';
    display: block;
    height: 1px;
    background: #EEEEEE;
    position: absolute;
    left: 10px;
    bottom: 0;
    right: 0;

  }

  .txt {
    position: relative;
    padding-left: 10px;
    line-height: 25px;

    &::after {
      content: '';
      display: block;
      width: 2px;
      height: 15px;
      background: #4573FF;
      position: absolute;
      left: 0;
      top: 0px;
    }
  }

}
</style>
 <style>.t-\[16\] {
    font-size: 16px
}
.t-\[\#303133\] {
    color: #303133
}
.font-600 {
    font-weight: 600
}</style>